// extracted by mini-css-extract-plugin
module.exports = {"section":"banner_about_me-module--section--Zy_DJ","title":"banner_about_me-module--title--1UuGD","subtitle":"banner_about_me-module--subtitle--8a6ee"};